import { alpha, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { createPortal } from 'react-dom';

import Loading from './Loading';
import SpinnerLoader from './SpinnerLoader';

const CenteredSpinnerOverlay = styled('div')(({ theme }) => {
  const varsPalette = theme.vars?.palette;
  const lightWhite = varsPalette?.common?.whiteChannel
    ? `rgba(${varsPalette.common.whiteChannel} / 0.78)`
    : alpha(theme.palette.common.white, 0.78);
  const lightPaper = varsPalette?.background?.paperChannel
    ? `rgba(${varsPalette.background.paperChannel} / 0.58)`
    : alpha(theme.palette.background.paper, 0.58);
  const lightDefault = varsPalette?.background?.defaultChannel
    ? `rgba(${varsPalette.background.defaultChannel} / 0.24)`
    : alpha(theme.palette.background.default, 0.24);

  const darkBlack = varsPalette?.common?.blackChannel
    ? `rgba(${varsPalette.common.blackChannel} / 0.76)`
    : alpha(theme.palette.common.black, 0.76);
  const darkPaper = varsPalette?.background?.paperChannel
    ? `rgba(${varsPalette.background.paperChannel} / 0.52)`
    : alpha(theme.palette.background.paper, 0.52);
  const darkDefault = varsPalette?.background?.defaultChannel
    ? `rgba(${varsPalette.background.defaultChannel} / 0.22)`
    : alpha(theme.palette.background.default, 0.22);

  return {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: theme.zIndex.tooltip + 2,
    pointerEvents: 'none',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundImage: `radial-gradient(circle at center, ${lightWhite} 0%, ${lightPaper} 22%, ${lightDefault} 48%, transparent 72%)`,
      ...theme.applyStyles('dark', {
        backgroundImage: `radial-gradient(circle at center, ${darkBlack} 0%, ${darkPaper} 24%, ${darkDefault} 50%, transparent 74%)`,
      }),
    },
  };
});

const CenteredSpinnerContent = styled('div')({
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
  pointerEvents: 'none',
});

const ModalLoadingFallback = ({
  label = 'Inhalt wird geladen',
  reducedMotion = false,
}) => {
  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <>
      <Loading label={label} />
      <CenteredSpinnerOverlay>
        <CenteredSpinnerContent>
          <SpinnerLoader
            label={label}
            reducedMotion={reducedMotion}
          />
        </CenteredSpinnerContent>
      </CenteredSpinnerOverlay>
    </>,
    document.body,
  );
};

ModalLoadingFallback.propTypes = {
  label: PropTypes.string,
  reducedMotion: PropTypes.bool,
};

export default ModalLoadingFallback;